import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePickerDaysExample.css";
import { ru } from "date-fns/locale/ru";
import { observer } from "mobx-react-lite";
import datasStore from "../../../store/DataStore";
import { format } from "date-fns";
registerLocale("ru", ru);

function parseYmdToLocalDate(ymd) {
  if (!ymd) return null;
  const d = new Date(`${ymd}T12:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}

const DatePickerDaysExample = observer(({ isFromDate, value, onChange }) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleInputFocus = () => {
    setIsCalendarOpen(true);
  };

  const handleInputBlur = () => {
    setIsCalendarOpen(false);
  };

  const handleChange = (date) => {
    if (!date) return;
    const formattedDate = format(date, "yyyy-MM-dd");
    if (onChange) {
      onChange(formattedDate);
      return;
    }
    if (isFromDate) {
      datasStore.setFromDate(formattedDate);
    } else {
      datasStore.setToDate(formattedDate);
    }
  };

  const ymd = value ?? (isFromDate ? datasStore.fromDate : datasStore.toDate);
  const selectedAsDate = parseYmdToLocalDate(ymd);

  return (
    <div className="date-picker-container">
      <DatePicker
        locale="ru"
        dateFormat="dd.MM.yyyy"
        selected={selectedAsDate}
        onChange={handleChange}
        customInput={
          <input
            className="date-picker-input"
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            readOnly
          />
        }
        inline={isCalendarOpen}
      />
    </div>
  );
});

export default DatePickerDaysExample;
